module.exports = "../study/imgs/maps/Tokyo/GWQ8/Climate/SummerDay/Tokyo_SummerDay_MRI_RCP85_End.png";